// import React, { useEffect, useState, useRef } from "react";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import { BASE_URL } from "../../config";
// import { getAuthHeaders } from "../../services/useAuth";
// import CustomButton from "../../pages/CustomButton";

// const RouteDetails = () => {
//   const { routeId } = useParams();
//   const location = useLocation();
//   const navigate = useNavigate();

//   const search = React.useMemo(
//     () => new URLSearchParams(location.search),
//     [location.search]
//   );
//   const qsRetailerId = search.get("retailerId") || search.get("retailer_id");
//   const qsRetailerType = (
//     search.get("retailer_type") ||
//     search.get("retailerType") ||
//     "doctor"
//   ).toLowerCase();

//   const effectiveRetailerId = qsRetailerId ? String(qsRetailerId) : null;
//   const effectiveRouteId = routeId ? String(routeId) : null;

//   const [routeData, setRouteData] = useState(null);
//   const [retailers, setRetailers] = useState([]);
//   const [allRoutes, setAllRoutes] = useState([]);
//   const [allAreas, setAllAreas] = useState([]);
//   const [routesByRetailer, setRoutesByRetailer] = useState({});
//   const [previousRoutesByEmployee, setPreviousRoutesByEmployee] = useState({});
//   const [selectedRoutes, setSelectedRoutes] = useState({});
//   const [selectedAreas, setSelectedAreas] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   const mountedRef = useRef(true);
//   useEffect(() => {
//     mountedRef.current = true;
//     return () => {
//       mountedRef.current = false;
//     };
//   }, []);

//   const formatDate = (d) => {
//     if (!d) return "";
//     const date = new Date(d);
//     if (Number.isNaN(date.getTime())) return String(d);
//     const months = [
//       "Jan",
//       "Feb",
//       "Mar",
//       "Apr",
//       "May",
//       "Jun",
//       "Jul",
//       "Aug",
//       "Sep",
//       "Oct",
//       "Nov",
//       "Dec",
//     ];
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = months[date.getMonth()];
//     const year = date.getFullYear();
//     return `${day} ${month} ${year}`;
//   };

//   // Build request params for combined-retailers endpoint
//   const buildParams = ({ routeId = null, retailerId = null } = {}) => {
//     const params = {
//       retailer_type: qsRetailerType || "doctor",
//       today_only: false,
//     };
//     if (retailerId != null) {
//       params.retailer_id = Number(retailerId);
//     } else if (effectiveRetailerId != null) {
//       params.retailer_id = Number(effectiveRetailerId);
//     } else {
//       const routeNum = Number(routeId ?? effectiveRouteId);
//       if (routeId != null && Number.isFinite(routeNum)) {
//         params.route_id = routeNum;
//       } else if (
//         effectiveRouteId != null &&
//         Number.isFinite(Number(effectiveRouteId))
//       ) {
//         params.route_id = Number(effectiveRouteId);
//       }
//     }
//     return params;
//   };

//   // Helpers to map name -> id using global lists
//   const findRouteIdByName = (name, globalRoutes = []) => {
//     if (!name) return null;
//     const lower = String(name).trim().toLowerCase();
//     const match = (globalRoutes || []).find((r) => {
//       const rn = String(r.route_name ?? r.name ?? "")
//         .trim()
//         .toLowerCase();
//       return rn === lower;
//     });
//     return match ? match.id : null;
//   };

//   const findAreaIdByName = (name, globalAreas = []) => {
//     if (!name) return null;
//     const lower = name.toString().trim().toLowerCase();
//     const match = (globalAreas || []).find((a) => {
//       const an = (a.name || "").toString().trim().toLowerCase();
//       return an === lower;
//     });
//     return match ? match.id : null;
//   };

//   // Fetch list of all routes (global list) - used for "global" dropdown options
//   const fetchAllRoutes = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/api/routes`, {
//         headers: getAuthHeaders(),
//       });
//       if (!mountedRef.current) return [];
//       // Normalize to array
//       const rows = Array.isArray(res?.data) ? res.data : res?.data?.rows || [];
//       setAllRoutes(rows || []);
//       return rows || [];
//     } catch {
//       if (mountedRef.current) setAllRoutes([]);
//       return [];
//     }
//   };

//   // Fetch areas (optionally for a city)
//   const fetchAreas = async (cityId = null) => {
//     try {
//       const areasUrl = cityId
//         ? `${BASE_URL}/api/areas/${cityId}`
//         : `${BASE_URL}/api/areas/`;
//       const res = await axios.get(areasUrl, { headers: getAuthHeaders() });
//       if (!mountedRef.current) return [];
//       setAllAreas(res?.data || []);
//       return res?.data || [];
//     } catch {
//       if (!mountedRef.current) return [];
//       setAllAreas([]);
//       return [];
//     }
//   };

//   // Fetch route details (single route)
//   const fetchRouteData = async (rId) => {
//     if (!rId) return null;
//     try {
//       const res = await axios.get(`${BASE_URL}/api/routes/${rId}`, {
//         headers: getAuthHeaders(),
//       });
//       if (!mountedRef.current) return null;
//       setRouteData(res?.data || null);
//       return res?.data || null;
//     } catch {
//       if (!mountedRef.current) return null;
//       setRouteData(null);
//       return null;
//     }
//   };

//   // Fetch retailers and also gather per-retailer route options.
//   // Returns { rows, perRetailerRoutes }
//   const fetchRetailers = async ({ routeId = null, retailerId = null } = {}) => {
//     try {
//       setError("");
//       const params = buildParams({ routeId, retailerId });
//       const url = `${BASE_URL}/api/combined-retailers`;
//       const res = await axios.get(url, { params, headers: getAuthHeaders() });
//       const payload = res?.data;
//       let rows = [];
//       if (Array.isArray(payload)) {
//         rows = payload;
//       } else if (payload && Array.isArray(payload.retailers)) {
//         rows = payload.retailers;
//       } else if (payload && Array.isArray(payload.rows)) {
//         rows = payload.rows;
//       } else if (
//         payload &&
//         typeof payload === "object" &&
//         (payload.id || payload.name)
//       ) {
//         rows = [payload];
//       } else {
//         rows = [];
//       }

//       // Build per-retailer route options from candidate keys
//       const candidateKeys = [
//         "routes",
//         "available_routes",
//         "previous_routes",
//         "route_options",
//         "route_list",
//       ];
//       const perRetailerRoutes = {};
//       rows.forEach((r) => {
//         let opts = [];
//         for (const k of candidateKeys) {
//           if (Array.isArray(r[k]) && r[k].length > 0) {
//             opts = r[k];
//             break;
//           }
//         }
//         perRetailerRoutes[r.id] = opts;
//       });

//       return { rows, perRetailerRoutes };
//     } catch (err) {
//       if (mountedRef.current)
//         setError(err?.message || "Failed to fetch retailers");
//       return { rows: [], perRetailerRoutes: {} };
//     }
//   };

//   // Fetch previous routes for an employee
//   const fetchPreviousRoutesForEmployee = async (employeeId) => {
//     if (!employeeId) return [];
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/api/previous_routes/employee/${employeeId}`,
//         {
//           headers: getAuthHeaders(),
//         }
//       );
//       return Array.isArray(res?.data) ? res.data : [];
//     } catch {
//       return [];
//     }
//   };

//   const setSelectedFromRows = (rows, globalRoutes = [], globalAreas = []) => {
//     const initialRoutes = {};
//     const initialAreas = {};

//     rows.forEach((r) => {
//       // prefer numeric id fields first
//       let selRouteId = r.route_id ?? r.current_route_id ?? r.routeId ?? null;

//       // if no numeric id, try to map by name to a global route id
//       if (selRouteId == null || selRouteId === "") {
//         // gather possible name candidates (preserve case)
//         const nameCandidates = [];
//         if (r.route_name) nameCandidates.push(String(r.route_name).trim());
//         if (r.current_route_name)
//           nameCandidates.push(String(r.current_route_name).trim());
//         if (r.present_route_name)
//           nameCandidates.push(String(r.present_route_name).trim());
//         if (r.present_route)
//           nameCandidates.push(String(r.present_route).trim());
//         if (r.routeName) nameCandidates.push(String(r.routeName).trim());

//         let mappedId = null;
//         for (const nm of nameCandidates) {
//           mappedId = findRouteIdByName(nm, globalRoutes);
//           if (mappedId != null) break;
//         }

//         if (mappedId != null) {
//           selRouteId = mappedId; // numeric id found
//         } else if (nameCandidates.length > 0) {
//           // no numeric mapping -> create a stable marker using the original name (preserve case)
//           selRouteId = `name::${nameCandidates[0]}`;
//         }
//       }

//       // store as trimmed string keyed by retailer id (string)
//       initialRoutes[String(r.id)] =
//         selRouteId == null ? "" : String(selRouteId).trim();

//       // AREA logic: try numeric id then name -> id, otherwise marker
//       let selAreaId = r.area_id ?? r.current_area_id ?? r.areaId ?? null;
//       if (selAreaId == null || selAreaId === "") {
//         const areaCandidates = [];
//         if (r.area_name) areaCandidates.push(String(r.area_name).trim());
//         if (r.current_area_name)
//           areaCandidates.push(String(r.current_area_name).trim());
//         if (r.area) areaCandidates.push(String(r.area).trim());

//         let mappedA = null;
//         for (const nm of areaCandidates) {
//           const matchA = (globalAreas || []).find(
//             (a) =>
//               String(a.name ?? a.area_name ?? "")
//                 .trim()
//                 .toLowerCase() === String(nm).trim().toLowerCase()
//           );
//           if (matchA) {
//             mappedA = matchA.id;
//             break;
//           }
//         }

//         if (mappedA != null) {
//           selAreaId = mappedA;
//         } else if (areaCandidates.length > 0) {
//           selAreaId = `name::${areaCandidates[0]}`;
//         }
//       }

//       initialAreas[String(r.id)] =
//         selAreaId == null ? "" : String(selAreaId).trim();
//     });

//     setSelectedRoutes(initialRoutes);
//     setSelectedAreas(initialAreas);

//     // debug (optional) - remove later
//     // eslint-disable-next-line no-console
//     console.log(
//       "initial selectedRoutes sample:",
//       Object.entries(initialRoutes).slice(0, 20)
//     );
//   };

//   useEffect(() => {
//     const init = async () => {
//       setLoading(true);
//       setError("");
//       try {
//         // fetch global routes
//         const globalRoutes = await fetchAllRoutes();

//         // fetch route data (if provided)
//         if (effectiveRouteId) {
//           await fetchRouteData(effectiveRouteId);
//         }

//         const { rows, perRetailerRoutes } = await fetchRetailers({
//           routeId: effectiveRouteId,
//           retailerId: effectiveRetailerId,
//         });

//         // Determine city id for areas: prefer routeData.city_id, then first row city, then query param
//         const cityIdFromRoute = routeData?.city_id ?? null;
//         const cityIdFromRow =
//           Array.isArray(rows) && rows.length > 0
//             ? rows[0].city_id ?? null
//             : null;
//         const cityIdToUse =
//           cityIdFromRoute || cityIdFromRow || search.get("city_id") || null;
//         const globalAreas = await fetchAreas(cityIdToUse);

//         // collect unique employee ids
//         const empIdSet = new Set();
//         rows.forEach((r) => {
//           const emp = r.employee_id ?? r.emp_id ?? null;
//           if (emp != null) empIdSet.add(Number(emp));
//         });
//         const empIds = Array.from(empIdSet);
//         const prevMap = {};
//         if (empIds.length > 0) {
//           const promises = empIds.map((eid) =>
//             fetchPreviousRoutesForEmployee(eid)
//           );
//           const results = await Promise.all(promises);
//           results.forEach((arr, idx) => {
//             prevMap[empIds[idx]] = Array.isArray(arr) ? arr : [];
//           });
//         }

//         // Build final per-retailer routes: prefer explicit perRetailerRoutes, otherwise previous routes for employee
//         const mergedPerRetailer = {};
//         rows.forEach((r) => {
//           const rowOpts =
//             Array.isArray(perRetailerRoutes[r.id]) &&
//             perRetailerRoutes[r.id].length > 0
//               ? perRetailerRoutes[r.id]
//               : [];
//           const emp = r.employee_id ?? r.emp_id ?? null;
//           const empPrev = emp != null ? prevMap[Number(emp)] || [] : [];
//           mergedPerRetailer[r.id] =
//             Array.isArray(rowOpts) && rowOpts.length > 0 ? rowOpts : empPrev;
//         });

//         if (!mountedRef.current) return;

//         setRetailers(rows);
//         setRoutesByRetailer(mergedPerRetailer);
//         setPreviousRoutesByEmployee(prevMap);
//         // use improved setter and pass global lists so names map to ids if possible
//         setSelectedFromRows(rows, globalRoutes, globalAreas);
//         setAllRoutes(globalRoutes);
//       } catch (err) {
//         if (mountedRef.current) setError("Initialization failed");
//       } finally {
//         if (mountedRef.current) setLoading(false);
//       }
//     };

//     init();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [routeId, location.search]);

//   // Handlers
//   const handleRouteChange = (retailerId, newRouteId) =>
//     setSelectedRoutes((prev) => ({ ...prev, [retailerId]: newRouteId }));
//   const handleAreaChange = (retailerId, newAreaId) =>
//     setSelectedAreas((prev) => ({ ...prev, [retailerId]: newAreaId }));

//   // Build display options for a retailer's routes.
//   // Ensures the selected route is included even if not in the options list.
//   const getRouteOptionsForRetailer = (retailerId) => {
//     const per = routesByRetailer[retailerId] || [];

//     const normalize = (r) => {
//       if (r == null) return null;
//       if (typeof r === "number" || typeof r === "string") {
//         const rStr = String(r).trim();
//         const match = (allRoutes || []).find(
//           (ar) =>
//             String(ar.id) === rStr ||
//             String(ar.route_name ?? ar.name ?? "")
//               .trim()
//               .toLowerCase() === rStr.toLowerCase()
//         );
//         if (match)
//           return {
//             id: String(match.id).trim(),
//             name: (match.route_name ?? match.name ?? String(match.id)).trim(),
//           };
//         return { id: rStr, name: rStr };
//       }
//       const id = r.id ?? r.route_id ?? null;
//       const name = r.route_name ?? r.name ?? "";
//       if (id != null)
//         return { id: String(id).trim(), name: String(name || id).trim() };
//       return { id: String(name).trim(), name: String(name).trim() };
//     };

//     const mapped = (Array.isArray(per) ? per : [])
//       .map(normalize)
//       .filter(Boolean);
//     const fallback = (allRoutes || []).map((ar) => ({
//       id: String(ar.id).trim(),
//       name: String(ar.route_name ?? ar.name ?? String(ar.id)).trim(),
//     }));
//     const merged = mapped.length > 0 ? mapped : fallback;

//     // Make sure 1) if the retailer object provides a name-only route, that option exists
//     const retailerObj =
//       retailers.find(
//         (r) => String(r.id) === String(retailerId) || r.id === retailerId
//       ) || null;
//     if (retailerObj) {
//       const rname =
//         retailerObj.route_name ??
//         retailerObj.current_route_name ??
//         retailerObj.present_route ??
//         null;
//       if (rname) {
//         const trimmed = String(rname).trim();
//         if (
//           !merged.some(
//             (m) =>
//               String(m.id) === trimmed ||
//               (m.name || "").toString().trim().toLowerCase() ===
//                 trimmed.toLowerCase()
//           )
//         ) {
//           // try map to global id first
//           const matchGlobal = (allRoutes || []).find(
//             (ar) =>
//               String(ar.route_name ?? ar.name ?? "")
//                 .trim()
//                 .toLowerCase() === trimmed.toLowerCase()
//           );
//           if (matchGlobal)
//             merged.unshift({
//               id: String(matchGlobal.id),
//               name:
//                 matchGlobal.route_name ??
//                 matchGlobal.name ??
//                 String(matchGlobal.id),
//             });
//           else merged.unshift({ id: `name::${trimmed}`, name: trimmed }); // use same marker format as setter
//         }
//       }
//     }

//     // Also ensure selectedRoutes entry is represented exactly (covers other markers)
//     const selectedVal = selectedRoutes[String(retailerId)];
//     if (
//       selectedVal !== undefined &&
//       selectedVal !== "" &&
//       !merged.some((m) => String(m.id) === String(selectedVal).trim())
//     ) {
//       const targ = String(selectedVal).trim();
//       // If targ is a marker already (name::...), create option with that exact id and display the name
//       if (targ.startsWith("name::")) {
//         merged.unshift({ id: targ, name: targ.replace(/^name::/, "") });
//       } else {
//         // try map by name or id
//         const match = (allRoutes || []).find(
//           (ar) =>
//             String(ar.id) === targ ||
//             String(ar.route_name ?? ar.name ?? "")
//               .trim()
//               .toLowerCase() === targ.toLowerCase()
//         );
//         if (match)
//           merged.unshift({
//             id: String(match.id),
//             name: match.route_name ?? match.name ?? String(match.id),
//           });
//         else merged.unshift({ id: targ, name: targ });
//       }
//     }

//     return merged; // each { id: string, name: string }
//   };

//   // Ensure areas options include selected area
//   const getAreaOptions = (retailerId) => {
//     const options = Array.isArray(allAreas)
//       ? allAreas.map((a) => ({ id: String(a.id), name: a.name }))
//       : [];
//     const selectedArea = selectedAreas[retailerId];
//     if (
//       selectedArea &&
//       !options.some((a) => String(a.id) === String(selectedArea))
//     ) {
//       // try find by name
//       const match = options.find(
//         (a) =>
//           (a.name || "").toString().trim().toLowerCase() ===
//           String(selectedArea).toString().trim().toLowerCase()
//       );
//       if (!match) {
//         // add a temporary option whose id is the name string
//         options.unshift({
//           id: String(selectedArea),
//           name: String(selectedArea),
//         });
//       } else {
//         // move matched option to front so it shows
//         const idx = options.indexOf(match);
//         if (idx > -1) {
//           options.splice(idx, 1);
//           options.unshift(match);
//         }
//       }
//     }
//     return options;
//   };

//   // Submit selected updates
//   const handleSubmit = async () => {
//     try {
//       setError("");
//       setSuccess("");

//       // Build updates array
//       const updates = retailers
//         .map((retailer) => {
//           const currentRoute =
//             retailer.route_id ?? retailer.current_route_id ?? null;
//           const currentArea =
//             retailer.area_id ?? retailer.current_area_id ?? null;

//           const newRouteRaw = selectedRoutes[retailer.id];
//           const newAreaRaw = selectedAreas[retailer.id];

//           // numeric if possible, else null (we send numeric ids to server)
//           const newRoute =
//             newRouteRaw === "" || newRouteRaw == null
//               ? null
//               : Number.isFinite(Number(newRouteRaw))
//               ? Number(newRouteRaw)
//               : null;
//           const newArea =
//             newAreaRaw === "" || newAreaRaw == null
//               ? null
//               : Number.isFinite(Number(newAreaRaw))
//               ? Number(newAreaRaw)
//               : null;

//           return {
//             retailer,
//             retailer_id: retailer.id,
//             retailer_code: retailer.code, // ensure code available
//             new_route_id: newRoute,
//             new_area_id: newArea,
//             current_route_id: currentRoute,
//             current_area_id: currentArea,
//             raw_new_route: newRouteRaw,
//             raw_new_area: newAreaRaw,
//           };
//         })
//         .filter(
//           (u) =>
//             (u.new_route_id !== u.current_route_id &&
//               (u.new_route_id !== null ||
//                 u.current_route_id !== null ||
//                 u.raw_new_route !== "")) ||
//             (u.new_area_id !== u.current_area_id &&
//               (u.new_area_id !== null ||
//                 u.current_area_id !== null ||
//                 u.raw_new_area !== ""))
//         );

//       if (updates.length === 0) {
//         setError("No changes detected");
//         return;
//       }

//       setLoading(true);

//       const results = await Promise.all(
//         updates.map(async (u) => {
//           const r = u.retailer;
//           try {
//             if ((qsRetailerType || "doctor").toLowerCase() === "doctor") {
//               const doctorPayload = {
//                 first_name: (r.first_name ?? r.firstName ?? r.name ?? "")
//                   .toString()
//                   .trim(),
//                 last_name: (r.last_name ?? r.lastName ?? "").toString().trim(),
//                 employee_id:
//                   r.employee_id != null
//                     ? Number(r.employee_id)
//                     : r.emp_id != null
//                     ? Number(r.emp_id)
//                     : null,
//                 city_id:
//                   r.city_id != null && r.city_id !== ""
//                     ? Number(r.city_id)
//                     : search.get("city_id")
//                     ? Number(search.get("city_id"))
//                     : null,
//                 area_id:
//                   u.new_area_id != null
//                     ? Number(u.new_area_id)
//                     : r.area_id != null
//                     ? Number(r.area_id)
//                     : r.current_area_id != null
//                     ? Number(r.current_area_id)
//                     : null,
//                 route_id:
//                   u.new_route_id != null
//                     ? Number(u.new_route_id)
//                     : r.route_id != null
//                     ? Number(r.route_id)
//                     : r.current_route_id != null
//                     ? Number(r.current_route_id)
//                     : null,
//               };

//               Object.keys(doctorPayload).forEach((k) => {
//                 if (doctorPayload[k] === undefined) doctorPayload[k] = null;
//               });

//               // Use retailer.code for doctor endpoint
//               const docEndpoint = `${BASE_URL}/api/doctors/${u.retailer_code}`;
//               const res = await axios.patch(docEndpoint, doctorPayload, {
//                 headers: getAuthHeaders(),
//               });
//               return { id: u.retailer_id, ok: true, data: res?.data };
//             }

//             const payload = {
//               chemist_name: (r.name ?? "").toString().trim(),
//               contact_person: (r.contact_person ?? r.contact_person_name ?? "")
//                 .toString()
//                 .trim(),
//               city_id:
//                 r.city_id != null && r.city_id !== ""
//                   ? Number(r.city_id)
//                   : null,
//               area_id:
//                 u.new_area_id != null
//                   ? Number(u.new_area_id)
//                   : r.area_id != null
//                   ? Number(r.area_id)
//                   : r.current_area_id != null
//                   ? Number(r.current_area_id)
//                   : null,
//               route_id:
//                 u.new_route_id != null
//                   ? Number(u.new_route_id)
//                   : r.route_id != null
//                   ? Number(r.route_id)
//                   : r.current_route_id != null
//                   ? Number(r.current_route_id)
//                   : null,
//               employee_id:
//                 r.employee_id != null
//                   ? Number(r.employee_id)
//                   : r.emp_id != null
//                   ? Number(r.emp_id)
//                   : null,
//             };

//             Object.keys(payload).forEach((k) => {
//               if (payload[k] === undefined) payload[k] = null;
//             });

//             const endpoint = `${BASE_URL}/api/chemist/chemist-retailer-id/${u.retailer_id}`;
//             const res = await axios.put(endpoint, payload, {
//               headers: getAuthHeaders(),
//             });
//             return { id: u.retailer_id, ok: true, data: res?.data };
//           } catch (err) {
//             const message =
//               err?.response?.data?.detail ||
//               err?.response?.data?.message ||
//               err?.response?.data ||
//               err?.message ||
//               "Request failed";
//             return { id: u.retailer_id, ok: false, error: message };
//           }
//         })
//       );

//       const failed = results.filter((r) => !r.ok);
//       const succeeded = results.filter((r) => r.ok);

//       if (succeeded.length > 0) {
//         setSuccess(`Updated: ${succeeded.map((s) => s.id).join(", ")}`);
//         // Re-initialize after changes to ensure dropdowns reflect saved values and options
//         // (this will fetch allRoutes, retailers, areas, previous routes again)
//         const globalRoutes = await fetchAllRoutes();
//         const { rows, perRetailerRoutes } = await fetchRetailers({
//           routeId: effectiveRouteId,
//           retailerId: effectiveRetailerId,
//         });

//         // Refresh previous routes by employees again
//         const empIdSet = new Set();
//         rows.forEach((r) => {
//           const emp = r.employee_id ?? r.emp_id ?? null;
//           if (emp != null) empIdSet.add(Number(emp));
//         });
//         const empIds = Array.from(empIdSet);
//         const prevMap = {};
//         if (empIds.length > 0) {
//           const promises = empIds.map((eid) =>
//             fetchPreviousRoutesForEmployee(eid)
//           );
//           const results2 = await Promise.all(promises);
//           results2.forEach((arr, idx) => {
//             prevMap[empIds[idx]] = Array.isArray(arr) ? arr : [];
//           });
//         }

//         const mergedPerRetailer = {};
//         rows.forEach((r) => {
//           const rowOpts =
//             Array.isArray(perRetailerRoutes[r.id]) &&
//             perRetailerRoutes[r.id].length > 0
//               ? perRetailerRoutes[r.id]
//               : [];
//           const emp = r.employee_id ?? r.emp_id ?? null;
//           const empPrev = emp != null ? prevMap[Number(emp)] || [] : [];
//           mergedPerRetailer[r.id] =
//             Array.isArray(rowOpts) && rowOpts.length > 0 ? rowOpts : empPrev;
//         });

//         if (!mountedRef.current) return;

//         setRetailers(rows);
//         setRoutesByRetailer(mergedPerRetailer);
//         setPreviousRoutesByEmployee(prevMap);
//         // Use improved setter with global lists
//         const cityIdFromRoute = routeData?.city_id ?? null;
//         const cityIdFromRow =
//           Array.isArray(rows) && rows.length > 0
//             ? rows[0].city_id ?? null
//             : null;
//         const cityIdToUse =
//           cityIdFromRoute || cityIdFromRow || search.get("city_id") || null;
//         const globalAreas = await fetchAreas(cityIdToUse);

//         setSelectedFromRows(rows, globalRoutes, globalAreas);
//         setAllRoutes(globalRoutes);
//       }

//       if (failed.length > 0) {
//         const details = failed
//           .map(
//             (f) =>
//               `${f.id}: ${
//                 typeof f.error === "string" ? f.error : JSON.stringify(f.error)
//               }`
//           )
//           .join("; ");
//         setError(`Failed: ${details}`);
//       }
//     } catch (err) {
//       console.error("handleSubmit top-level error", err);
//       setError("Failed to update routes and areas");
//     } finally {
//       if (mountedRef.current) setLoading(false);
//     }
//   };

//   const handleCancel = () => {
//     const originalRoutes = {};
//     const originalAreas = {};
//     retailers.forEach((r) => {
//       originalRoutes[r.id] =
//         r.route_id ?? r.current_route_id ?? r.route_name ?? "";
//       originalAreas[r.id] = r.area_id ?? r.current_area_id ?? r.area_name ?? "";
//     });
//     // store as strings to match select values
//     const originalRoutesStr = Object.fromEntries(
//       Object.entries(originalRoutes).map(([k, v]) => [
//         k,
//         v == null ? "" : String(v),
//       ])
//     );
//     const originalAreasStr = Object.fromEntries(
//       Object.entries(originalAreas).map(([k, v]) => [
//         k,
//         v == null ? "" : String(v),
//       ])
//     );

//     setSelectedRoutes(originalRoutesStr);
//     setSelectedAreas(originalAreasStr);
//     setError("");
//     setSuccess("");
//   };


//   if (loading)
//     return (
//       <div className="route-details-loading">Loading route details...</div>
//     );


//   return (
//     <div className="route-details-container">
//       <div className="route-details-header" style={{ textAlign: "center" }}>
//         <h1>Assign Retailer to Routes</h1>
//         <p style={{ marginTop: 6 }}>
//           {effectiveRetailerId
//             ? `Viewing retailer ${effectiveRetailerId} (type: ${qsRetailerType})`
//             : `Viewing route ${effectiveRouteId || "N/A"}`}
//         </p>
//       </div>

//       {error && <div style={{ color: "red", marginTop: 8 }}>{error}</div>}
//       {success && <div style={{ color: "green", marginTop: 8 }}>{success}</div>}

//        <div className="border rounded shadow table-wrapper">
//   <table className="unlock-dcr-leave-table text-sm w-full">
//     <thead className="bg-blue-500 text-white text-center">
//       <tr>
//         <th style={{ padding: 8 }}>S.No</th>
//         <th style={{ padding: 8 }}>Id</th>
//         <th style={{ padding: 8 }}>Code</th>
//         <th style={{ padding: 8 }}>Retailer</th>
//         <th style={{ padding: 8 }}>Mobile</th>
//         <th style={{ padding: 8 }}>Present Route</th>
//         <th style={{ padding: 8 }}>New Route</th>
//         <th style={{ padding: 8 }}>Area</th>
//         <th style={{ padding: 8 }}>City</th>
//       </tr>
//     </thead>

//     <tbody className="text-center">
//       {retailers.length > 0 ? (
//         retailers.map((retailer, index) => (
//           <tr key={retailer.id} style={{ borderTop: "1px solid #eee" }}>
//             <td style={{ padding: 8 }}>{index + 1}</td>

//             <td style={{ padding: 8 }}>
//               {retailer.setup_code ?? retailer.id}
//             </td>
//             <td style={{ padding: 8 }}>{retailer.code}</td>
//             <td style={{ padding: 8 }}>{retailer.name}</td>
//             <td style={{ padding: 8 }}>{retailer.mobile || "N/A"}</td>

//             <td style={{ padding: 8 }}>
//               {retailer.route_name ||
//                 retailer.current_route_name ||
//                 "N/A"}
//             </td>

//             <td style={{ padding: 8 }}>
//               <select
//                 value={String(selectedRoutes[retailer.id] ?? "")}
//                 onChange={(e) =>
//                   handleRouteChange(retailer.id, e.target.value)
//                 }
//                 className="route-dropdown text-center"
//               >
//                 <option value="">Select Route</option>
//                 {getRouteOptionsForRetailer(retailer.id).map((route) => (
//                   <option key={String(route.id)} value={String(route.id)}>
//                     {route.name}
//                   </option>
//                 ))}
//               </select>
//             </td>

//             <td style={{ padding: 8 }}>
//               <select
//                 value={String(selectedAreas[retailer.id] ?? "")}
//                 onChange={(e) =>
//                   handleAreaChange(retailer.id, e.target.value)
//                 }
//                 className="area-dropdown text-center"
//               >
//                 <option value="">Select Area</option>
//                 {getAreaOptions(retailer.id).map((area) => (
//                   <option key={String(area.id)} value={String(area.id)}>
//                     {area.name}
//                   </option>
//                 ))}
//               </select>
//             </td>

//             <td style={{ padding: 8 }}>{retailer.city_name || "N/A"}</td>
//           </tr>
//         ))
//       ) : (
//         <tr>
//           <td colSpan={9} style={{ padding: 16, textAlign: "center" }}>
//             No retailers found for this route
//           </td>
//         </tr>
//       )}
//     </tbody>
//   </table>
// </div>

//       <div style={{ marginTop: 16, display: "flex", justifyContent: "center" }}>
//         <CustomButton variant="save" onClick={handleSubmit}>
//           Submit
//         </CustomButton>
//         <CustomButton
//           variant="cancel"
//           onClick={handleCancel}
//           style={{ marginLeft: 8 }}
//         >
//           Cancel
//         </CustomButton>
     
//       </div>
//     </div>
//   );
// };

// export default RouteDetails;
import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../../config";
import { getAuthHeaders } from "../../services/useAuth";
import CustomButton from "../../pages/CustomButton";
import Loader from "../../dist/Loader";

const RouteDetails = () => {
  const { routeId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const search = React.useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const qsRetailerId = search.get("retailerId") || search.get("retailer_id");
  const qsRetailerType = (
    search.get("retailer_type") ||
    search.get("retailerType") ||
    "doctor"
  ).toLowerCase();

  const effectiveRetailerId = qsRetailerId ? String(qsRetailerId) : null;
  const effectiveRouteId = routeId ? String(routeId) : null;

  const [routeData, setRouteData] = useState(null);
  const [retailers, setRetailers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // Routes scoped per "employeeId_cityId" key -> array of route objects
  const [routesByEmployeeCity, setRoutesByEmployeeCity] = useState({});
  const [allAreas, setAllAreas] = useState([]);
  const [routesByRetailer, setRoutesByRetailer] = useState({});
  const [previousRoutesByEmployee, setPreviousRoutesByEmployee] = useState({});
  const [selectedRoutes, setSelectedRoutes] = useState({});
  const [selectedAreas, setSelectedAreas] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const mountedRef = useRef(true);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const formatDate = (d) => {
    if (!d) return "";
    const date = new Date(d);
    if (Number.isNaN(date.getTime())) return String(d);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  // Build request params for combined-retailers endpoint
  const buildParams = ({ routeId = null, retailerId = null } = {}) => {
    const params = {
      retailer_type: qsRetailerType || "doctor",
      today_only: false,
    };
    if (retailerId != null) {
      params.retailer_id = Number(retailerId);
    } else if (effectiveRetailerId != null) {
      params.retailer_id = Number(effectiveRetailerId);
    } else {
      const routeNum = Number(routeId ?? effectiveRouteId);
      if (routeId != null && Number.isFinite(routeNum)) {
        params.route_id = routeNum;
      } else if (
        effectiveRouteId != null &&
        Number.isFinite(Number(effectiveRouteId))
      ) {
        params.route_id = Number(effectiveRouteId);
      }
    }
    return params;
  };

  // ---------------------------------------------------------------------
  // Helper: build a stable key for the per-employee/city route cache
  // ---------------------------------------------------------------------
  const empCityKey = (employeeId, cityId) =>
    `${employeeId ?? "none"}_${cityId ?? "none"}`;

  // Helpers to map name -> id using a given routes list (employee/city scoped)
  const findRouteIdByName = (name, routesList = []) => {
    if (!name) return null;
    const lower = String(name).trim().toLowerCase();
    const match = (routesList || []).find((r) => {
      const rn = String(r.route_name ?? r.name ?? "")
        .trim()
        .toLowerCase();
      return rn === lower;
    });
    return match ? match.id : null;
  };

  // ---------------------------------------------------------------------
  // Fetch routes scoped to a specific employee + city
  // Expected endpoint shape: /api/routes/{employee_id}/?city_id={city_id}
  // ---------------------------------------------------------------------
  const fetchRoutesForEmployeeCity = async (employeeId, cityId) => {
    if (employeeId == null) return [];
    try {
      const params = {};
      if (cityId != null && cityId !== "") {
        params.city_id = Number(cityId);
      }
      const res = await axios.get(`${BASE_URL}/api/routes/${employeeId}/`, {
        params,
        headers: getAuthHeaders(),
      });
      const rows = Array.isArray(res?.data) ? res.data : res?.data?.rows || [];
      return rows || [];
    } catch {
      return [];
    }
  };

  // Given the (filtered) retailer rows, fetch routes for every unique
  // employee_id + city_id combination and return a lookup map.
  const fetchRoutesForRows = async (rows) => {
    const pairs = new Map(); // key -> { employeeId, cityId }

    rows.forEach((r) => {
      const emp = r.employee_id ?? r.emp_id ?? null;
      const city = r.city_id ?? null;
      if (emp != null) {
        pairs.set(empCityKey(emp, city), { employeeId: emp, cityId: city });
      }
    });

    const routesMap = {};
    await Promise.all(
      Array.from(pairs.entries()).map(async ([key, { employeeId, cityId }]) => {
        const routes = await fetchRoutesForEmployeeCity(employeeId, cityId);
        routesMap[key] = routes;
      })
    );

    return routesMap;
  };

  // Fetch areas (optionally for a city)
  const fetchAreas = async (cityId = null) => {
    try {
      const areasUrl = cityId
        ? `${BASE_URL}/api/areas/${cityId}`
        : `${BASE_URL}/api/areas/`;
      const res = await axios.get(areasUrl, { headers: getAuthHeaders() });
      if (!mountedRef.current) return [];
      setAllAreas(res?.data || []);
      return res?.data || [];
    } catch {
      if (!mountedRef.current) return [];
      setAllAreas([]);
      return [];
    }
  };

  // Fetch route details (single route)
  const fetchRouteData = async (rId) => {
    if (!rId) return null;
    try {
      const res = await axios.get(`${BASE_URL}/api/routes/${rId}`, {
        headers: getAuthHeaders(),
      });
      if (!mountedRef.current) return null;
      setRouteData(res?.data || null);
      return res?.data || null;
    } catch {
      if (!mountedRef.current) return null;
      setRouteData(null);
      return null;
    }
  };

  // ---------------------------------------------------------------------
  // Fetch retailers and also gather per-retailer route options.
  // Returns { rows, perRetailerRoutes }
  // IMPORTANT: filters out non-retailer payload entries (e.g. the trailing
  // `{ summary: {...} }` aggregate object returned by combined-retailers)
  // ---------------------------------------------------------------------
  const fetchRetailers = async ({ routeId = null, retailerId = null } = {}) => {
    try {
      setError("");
      const params = buildParams({ routeId, retailerId });
      const url = `${BASE_URL}/api/combined-retailers`;
      const res = await axios.get(url, { params, headers: getAuthHeaders() });
      const payload = res?.data;
      let rawRows = [];
      if (Array.isArray(payload)) {
        rawRows = payload;
      } else if (payload && Array.isArray(payload.retailers)) {
        rawRows = payload.retailers;
      } else if (payload && Array.isArray(payload.rows)) {
        rawRows = payload.rows;
      } else if (
        payload &&
        typeof payload === "object" &&
        (payload.id || payload.name)
      ) {
        rawRows = [payload];
      } else {
        rawRows = [];
      }

      // Drop entries that are not actual retailer records.
      // The API can append a trailing `{ summary: {...} }` object that has
      // no `id`/retailer fields - exclude anything that looks like that.
      const rows = rawRows.filter(
        (r) =>
          r &&
          typeof r === "object" &&
          !("summary" in r) &&
          r.id != null
      );

      // Build per-retailer route options from candidate keys
      const candidateKeys = [
        "routes",
        "available_routes",
        "previous_routes",
        "route_options",
        "route_list",
      ];
      const perRetailerRoutes = {};
      rows.forEach((r) => {
        let opts = [];
        for (const k of candidateKeys) {
          if (Array.isArray(r[k]) && r[k].length > 0) {
            opts = r[k];
            break;
          }
        }
        perRetailerRoutes[r.id] = opts;
      });

      return { rows, perRetailerRoutes };
    } catch (err) {
      if (mountedRef.current)
        setError(err?.message || "Failed to fetch retailers");
      return { rows: [], perRetailerRoutes: {} };
    }
  };

  // Fetch previous routes for an employee
  const fetchPreviousRoutesForEmployee = async (employeeId) => {
    if (!employeeId) return [];
    try {
      const res = await axios.get(
        `${BASE_URL}/api/previous_routes/employee/${employeeId}`,
        {
          headers: getAuthHeaders(),
        }
      );
      return Array.isArray(res?.data) ? res.data : [];
    } catch {
      return [];
    }
  };

  // routesMap: map of "employeeId_cityId" -> route[] (used to map route
  // names to ids per retailer, scoped to that retailer's employee/city)
  const setSelectedFromRows = (rows, routesMap = {}, globalAreas = []) => {
    const initialRoutes = {};
    const initialAreas = {};

    rows.forEach((r) => {
      const emp = r.employee_id ?? r.emp_id ?? null;
      const city = r.city_id ?? null;
      const scopedRoutes = routesMap[empCityKey(emp, city)] || [];

      // prefer numeric id fields first
      let selRouteId = r.route_id ?? r.current_route_id ?? r.routeId ?? null;

      // if no numeric id, try to map by name to a scoped route id
      if (selRouteId == null || selRouteId === "") {
        // gather possible name candidates (preserve case)
        const nameCandidates = [];
        if (r.route_name) nameCandidates.push(String(r.route_name).trim());
        if (r.current_route_name)
          nameCandidates.push(String(r.current_route_name).trim());
        if (r.present_route_name)
          nameCandidates.push(String(r.present_route_name).trim());
        if (r.present_route)
          nameCandidates.push(String(r.present_route).trim());
        if (r.routeName) nameCandidates.push(String(r.routeName).trim());

        let mappedId = null;
        for (const nm of nameCandidates) {
          mappedId = findRouteIdByName(nm, scopedRoutes);
          if (mappedId != null) break;
        }

        if (mappedId != null) {
          selRouteId = mappedId; // numeric id found
        } else if (nameCandidates.length > 0) {
          // no numeric mapping -> create a stable marker using the original name (preserve case)
          selRouteId = `name::${nameCandidates[0]}`;
        }
      }

      // store as trimmed string keyed by retailer id (string)
      initialRoutes[String(r.id)] =
        selRouteId == null ? "" : String(selRouteId).trim();

      // AREA logic: try numeric id then name -> id, otherwise marker
      let selAreaId = r.area_id ?? r.current_area_id ?? r.areaId ?? null;
      if (selAreaId == null || selAreaId === "") {
        const areaCandidates = [];
        if (r.area_name) areaCandidates.push(String(r.area_name).trim());
        if (r.current_area_name)
          areaCandidates.push(String(r.current_area_name).trim());
        if (r.area) areaCandidates.push(String(r.area).trim());

        let mappedA = null;
        for (const nm of areaCandidates) {
          const matchA = (globalAreas || []).find(
            (a) =>
              String(a.name ?? a.area_name ?? "")
                .trim()
                .toLowerCase() === String(nm).trim().toLowerCase()
          );
          if (matchA) {
            mappedA = matchA.id;
            break;
          }
        }

        if (mappedA != null) {
          selAreaId = mappedA;
        } else if (areaCandidates.length > 0) {
          selAreaId = `name::${areaCandidates[0]}`;
        }
      }

      initialAreas[String(r.id)] =
        selAreaId == null ? "" : String(selAreaId).trim();
    });

    setSelectedRoutes(initialRoutes);
    setSelectedAreas(initialAreas);

    // debug (optional) - remove later
    // eslint-disable-next-line no-console
    console.log(
      "initial selectedRoutes sample:",
      Object.entries(initialRoutes).slice(0, 20)
    );
  };

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      setError("");
      try {
        // fetch route data (if provided)
        if (effectiveRouteId) {
          await fetchRouteData(effectiveRouteId);
        }

        const { rows, perRetailerRoutes } = await fetchRetailers({
          routeId: effectiveRouteId,
          retailerId: effectiveRetailerId,
        });

        // Determine city id for areas: prefer routeData.city_id, then first row city, then query param
        const cityIdFromRoute = routeData?.city_id ?? null;
        const cityIdFromRow =
          Array.isArray(rows) && rows.length > 0
            ? rows[0].city_id ?? null
            : null;
        const cityIdToUse =
          cityIdFromRoute || cityIdFromRow || search.get("city_id") || null;

        // collect unique employee ids
        const empIdSet = new Set();
        rows.forEach((r) => {
          const emp = r.employee_id ?? r.emp_id ?? null;
          if (emp != null) empIdSet.add(Number(emp));
        });
        const empIds = Array.from(empIdSet);

        // Fire all independent requests concurrently instead of waiting
        // on each one in sequence - this is the main source of the slow
        // load (each of these can take a noticeable amount of time on
        // the backend, and they don't depend on each other).
        const [routesMap, globalAreas, prevResults] = await Promise.all([
          fetchRoutesForRows(rows),
          fetchAreas(cityIdToUse),
          Promise.all(empIds.map((eid) => fetchPreviousRoutesForEmployee(eid))),
        ]);

        const prevMap = {};
        prevResults.forEach((arr, idx) => {
          prevMap[empIds[idx]] = Array.isArray(arr) ? arr : [];
        });

        // Build final per-retailer routes: prefer explicit perRetailerRoutes,
        // otherwise routes scoped to the retailer's employee+city, otherwise
        // previous routes for the employee
        const mergedPerRetailer = {};
        rows.forEach((r) => {
          const emp = r.employee_id ?? r.emp_id ?? null;
          const city = r.city_id ?? null;
          const scopedRoutes = routesMap[empCityKey(emp, city)] || [];

          const rowOpts =
            Array.isArray(perRetailerRoutes[r.id]) &&
            perRetailerRoutes[r.id].length > 0
              ? perRetailerRoutes[r.id]
              : [];

          const empPrev = emp != null ? prevMap[Number(emp)] || [] : [];

          if (rowOpts.length > 0) {
            mergedPerRetailer[r.id] = rowOpts;
          } else if (scopedRoutes.length > 0) {
            mergedPerRetailer[r.id] = scopedRoutes;
          } else {
            mergedPerRetailer[r.id] = empPrev;
          }
        });

        if (!mountedRef.current) return;

        setRetailers(rows);
        setRoutesByRetailer(mergedPerRetailer);
        setPreviousRoutesByEmployee(prevMap);
        setRoutesByEmployeeCity(routesMap);
        // use improved setter and pass employee/city scoped routes so names map to ids if possible
        setSelectedFromRows(rows, routesMap, globalAreas);
      } catch (err) {
        if (mountedRef.current) setError("Initialization failed");
      } finally {
        if (mountedRef.current) setLoading(false);
      }
    };

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeId, location.search]);

  // Handlers
  const handleRouteChange = (retailerId, newRouteId) =>
    setSelectedRoutes((prev) => ({ ...prev, [retailerId]: newRouteId }));
  const handleAreaChange = (retailerId, newAreaId) =>
    setSelectedAreas((prev) => ({ ...prev, [retailerId]: newAreaId }));
  const getRouteOptionsForRetailer = (retailerId) => {
    const retailerObj =
      retailers.find(
        (r) => String(r.id) === String(retailerId) || r.id === retailerId
      ) || null;

    const emp = retailerObj?.employee_id ?? retailerObj?.emp_id ?? null;
    const city = retailerObj?.city_id ?? null;
    const scopedRoutes = routesByEmployeeCity[empCityKey(emp, city)] || [];

    const per = routesByRetailer[retailerId] || [];
    const sourceList = (Array.isArray(per) && per.length > 0) ? per : scopedRoutes;

    const normalize = (r) => {
      if (r == null) return null;
      if (typeof r === "number" || typeof r === "string") {
        const rStr = String(r).trim();
        const match = (sourceList || []).find(
          (ar) =>
            String(ar.id) === rStr ||
            String(ar.route_name ?? ar.name ?? "")
              .trim()
              .toLowerCase() === rStr.toLowerCase()
        );
        if (match)
          return {
            id: String(match.id).trim(),
            name: (match.route_name ?? match.name ?? String(match.id)).trim(),
          };
        return { id: rStr, name: rStr };
      }
      const id = r.id ?? r.route_id ?? null;
      const name = r.route_name ?? r.name ?? "";
      if (id != null)
        return { id: String(id).trim(), name: String(name || id).trim() };
      return { id: String(name).trim(), name: String(name).trim() };
    };

    const merged = (Array.isArray(sourceList) ? sourceList : [])
      .map(normalize)
      .filter(Boolean);

    // Make sure 1) if the retailer object provides a name-only route, that option exists
    if (retailerObj) {
      const rname =
        retailerObj.route_name ??
        retailerObj.current_route_name ??
        retailerObj.present_route ??
        null;
      if (rname) {
        const trimmed = String(rname).trim();
        if (
          !merged.some(
            (m) =>
              String(m.id) === trimmed ||
              (m.name || "").toString().trim().toLowerCase() ===
                trimmed.toLowerCase()
          )
        ) {
          // try map to a scoped route id first
          const matchScoped = (scopedRoutes || []).find(
            (ar) =>
              String(ar.route_name ?? ar.name ?? "")
                .trim()
                .toLowerCase() === trimmed.toLowerCase()
          );
          if (matchScoped)
            merged.unshift({
              id: String(matchScoped.id),
              name:
                matchScoped.route_name ??
                matchScoped.name ??
                String(matchScoped.id),
            });
          else merged.unshift({ id: `name::${trimmed}`, name: trimmed }); // use same marker format as setter
        }
      }
    }

    // Also ensure selectedRoutes entry is represented exactly (covers other markers)
    const selectedVal = selectedRoutes[String(retailerId)];
    if (
      selectedVal !== undefined &&
      selectedVal !== "" &&
      !merged.some((m) => String(m.id) === String(selectedVal).trim())
    ) {
      const targ = String(selectedVal).trim();
      // If targ is a marker already (name::...), create option with that exact id and display the name
      if (targ.startsWith("name::")) {
        merged.unshift({ id: targ, name: targ.replace(/^name::/, "") });
      } else {
        // try map by name or id within the scoped routes
        const match = (scopedRoutes || []).find(
          (ar) =>
            String(ar.id) === targ ||
            String(ar.route_name ?? ar.name ?? "")
              .trim()
              .toLowerCase() === targ.toLowerCase()
        );
        if (match)
          merged.unshift({
            id: String(match.id),
            name: match.route_name ?? match.name ?? String(match.id),
          });
        else merged.unshift({ id: targ, name: targ });
      }
    }

    return merged; 
  };

  // Ensure areas options include selected area
  const getAreaOptions = (retailerId) => {
    const options = Array.isArray(allAreas)
      ? allAreas.map((a) => ({ id: String(a.id), name: a.name }))
      : [];
    const selectedArea = selectedAreas[retailerId];
    if (
      selectedArea &&
      !options.some((a) => String(a.id) === String(selectedArea))
    ) {
      // try find by name
      const match = options.find(
        (a) =>
          (a.name || "").toString().trim().toLowerCase() ===
          String(selectedArea).toString().trim().toLowerCase()
      );
      if (!match) {
        options.unshift({
          id: String(selectedArea),
          name: String(selectedArea),
        });
      } else {
        const idx = options.indexOf(match);
        if (idx > -1) {
          options.splice(idx, 1);
          options.unshift(match);
        }
      }
    }
    return options;
  };

  // ---------------------------------------------------------------------
  // Re-fetch everything (used after a successful submit)
  // ---------------------------------------------------------------------
  const refetchAll = async () => {
    const { rows, perRetailerRoutes } = await fetchRetailers({
      routeId: effectiveRouteId,
      retailerId: effectiveRetailerId,
    });

    const cityIdFromRoute = routeData?.city_id ?? null;
    const cityIdFromRow =
      Array.isArray(rows) && rows.length > 0 ? rows[0].city_id ?? null : null;
    const cityIdToUse =
      cityIdFromRoute || cityIdFromRow || search.get("city_id") || null;

    const empIdSet = new Set();
    rows.forEach((r) => {
      const emp = r.employee_id ?? r.emp_id ?? null;
      if (emp != null) empIdSet.add(Number(emp));
    });
    const empIds = Array.from(empIdSet);

    const [routesMap, globalAreas, prevResults] = await Promise.all([
      fetchRoutesForRows(rows),
      fetchAreas(cityIdToUse),
      Promise.all(empIds.map((eid) => fetchPreviousRoutesForEmployee(eid))),
    ]);

    const prevMap = {};
    prevResults.forEach((arr, idx) => {
      prevMap[empIds[idx]] = Array.isArray(arr) ? arr : [];
    });

    const mergedPerRetailer = {};
    rows.forEach((r) => {
      const emp = r.employee_id ?? r.emp_id ?? null;
      const city = r.city_id ?? null;
      const scopedRoutes = routesMap[empCityKey(emp, city)] || [];

      const rowOpts =
        Array.isArray(perRetailerRoutes[r.id]) &&
        perRetailerRoutes[r.id].length > 0
          ? perRetailerRoutes[r.id]
          : [];

      const empPrev = emp != null ? prevMap[Number(emp)] || [] : [];

      if (rowOpts.length > 0) {
        mergedPerRetailer[r.id] = rowOpts;
      } else if (scopedRoutes.length > 0) {
        mergedPerRetailer[r.id] = scopedRoutes;
      } else {
        mergedPerRetailer[r.id] = empPrev;
      }
    });

    if (!mountedRef.current) return;

    setRetailers(rows);
    setRoutesByRetailer(mergedPerRetailer);
    setPreviousRoutesByEmployee(prevMap);
    setRoutesByEmployeeCity(routesMap);

    setSelectedFromRows(rows, routesMap, globalAreas);
  };

  // Submit selected updates
  const handleSubmit = async () => {
    try {
      setError("");
      setSuccess("");

      // Build updates array
      const updates = retailers
        .map((retailer) => {
          const currentRoute =
            retailer.route_id ?? retailer.current_route_id ?? null;
          const currentArea =
            retailer.area_id ?? retailer.current_area_id ?? null;

          const newRouteRaw = selectedRoutes[retailer.id];
          const newAreaRaw = selectedAreas[retailer.id];

          // numeric if possible, else null (we send numeric ids to server)
          const newRoute =
            newRouteRaw === "" || newRouteRaw == null
              ? null
              : Number.isFinite(Number(newRouteRaw))
              ? Number(newRouteRaw)
              : null;
          const newArea =
            newAreaRaw === "" || newAreaRaw == null
              ? null
              : Number.isFinite(Number(newAreaRaw))
              ? Number(newAreaRaw)
              : null;

          return {
            retailer,
            retailer_id: retailer.id,
            retailer_code: retailer.code, // ensure code available
            new_route_id: newRoute,
            new_area_id: newArea,
            current_route_id: currentRoute,
            current_area_id: currentArea,
            raw_new_route: newRouteRaw,
            raw_new_area: newAreaRaw,
          };
        })
        .filter(
          (u) =>
            (u.new_route_id !== u.current_route_id &&
              (u.new_route_id !== null ||
                u.current_route_id !== null ||
                u.raw_new_route !== "")) ||
            (u.new_area_id !== u.current_area_id &&
              (u.new_area_id !== null ||
                u.current_area_id !== null ||
                u.raw_new_area !== ""))
        );

      if (updates.length === 0) {
        setError("No changes detected");
        return;
      }

      setLoading(true);

      const results = await Promise.all(
        updates.map(async (u) => {
          const r = u.retailer;
          try {
            if ((qsRetailerType || "doctor").toLowerCase() === "doctor") {
              const doctorPayload = {
                first_name: (r.first_name ?? r.firstName ?? r.name ?? "")
                  .toString()
                  .trim(),
                last_name: (r.last_name ?? r.lastName ?? "").toString().trim(),
                employee_id:
                  r.employee_id != null
                    ? Number(r.employee_id)
                    : r.emp_id != null
                    ? Number(r.emp_id)
                    : null,
                city_id:
                  r.city_id != null && r.city_id !== ""
                    ? Number(r.city_id)
                    : search.get("city_id")
                    ? Number(search.get("city_id"))
                    : null,
                area_id:
                  u.new_area_id != null
                    ? Number(u.new_area_id)
                    : r.area_id != null
                    ? Number(r.area_id)
                    : r.current_area_id != null
                    ? Number(r.current_area_id)
                    : null,
                route_id:
                  u.new_route_id != null
                    ? Number(u.new_route_id)
                    : r.route_id != null
                    ? Number(r.route_id)
                    : r.current_route_id != null
                    ? Number(r.current_route_id)
                    : null,
              };

              Object.keys(doctorPayload).forEach((k) => {
                if (doctorPayload[k] === undefined) doctorPayload[k] = null;
              });

              // Use retailer.code for doctor endpoint
              const docEndpoint = `${BASE_URL}/api/doctors/${u.retailer_code}`;
              const res = await axios.patch(docEndpoint, doctorPayload, {
                headers: getAuthHeaders(),
              });
              return { id: u.retailer_id, ok: true, data: res?.data };
            }

            const payload = {
              chemist_name: (r.name ?? "").toString().trim(),
              contact_person: (r.contact_person ?? r.contact_person_name ?? "")
                .toString()
                .trim(),
              city_id:
                r.city_id != null && r.city_id !== ""
                  ? Number(r.city_id)
                  : null,
              area_id:
                u.new_area_id != null
                  ? Number(u.new_area_id)
                  : r.area_id != null
                  ? Number(r.area_id)
                  : r.current_area_id != null
                  ? Number(r.current_area_id)
                  : null,
              route_id:
                u.new_route_id != null
                  ? Number(u.new_route_id)
                  : r.route_id != null
                  ? Number(r.route_id)
                  : r.current_route_id != null
                  ? Number(r.current_route_id)
                  : null,
              employee_id:
                r.employee_id != null
                  ? Number(r.employee_id)
                  : r.emp_id != null
                  ? Number(r.emp_id)
                  : null,
            };

            Object.keys(payload).forEach((k) => {
              if (payload[k] === undefined) payload[k] = null;
            });

            const endpoint = `${BASE_URL}/api/chemist/chemist-retailer-id/${u.retailer_id}`;
            const res = await axios.put(endpoint, payload, {
              headers: getAuthHeaders(),
            });
            return { id: u.retailer_id, ok: true, data: res?.data };
          } catch (err) {
            const message =
              err?.response?.data?.detail ||
              err?.response?.data?.message ||
              err?.response?.data ||
              err?.message ||
              "Request failed";
            return { id: u.retailer_id, ok: false, error: message };
          }
        })
      );

      const failed = results.filter((r) => !r.ok);
      const succeeded = results.filter((r) => r.ok);

      if (succeeded.length > 0) {
        setSuccess(`Updated: ${succeeded.map((s) => s.id).join(", ")}`);
        await refetchAll();
      }

      if (failed.length > 0) {
        const details = failed
          .map(
            (f) =>
              `${f.id}: ${
                typeof f.error === "string" ? f.error : JSON.stringify(f.error)
              }`
          )
          .join("; ");
        setError(`Failed: ${details}`);
      }
    } catch (err) {
      console.error("handleSubmit top-level error", err);
      setError("Failed to update routes and areas");
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  };

  const handleCancel = () => {
    const originalRoutes = {};
    const originalAreas = {};
    retailers.forEach((r) => {
      originalRoutes[r.id] =
        r.route_id ?? r.current_route_id ?? r.route_name ?? "";
      originalAreas[r.id] = r.area_id ?? r.current_area_id ?? r.area_name ?? "";
    });
    // store as strings to match select values
    const originalRoutesStr = Object.fromEntries(
      Object.entries(originalRoutes).map(([k, v]) => [
        k,
        v == null ? "" : String(v),
      ])
    );
    const originalAreasStr = Object.fromEntries(
      Object.entries(originalAreas).map(([k, v]) => [
        k,
        v == null ? "" : String(v),
      ])
    );

    setSelectedRoutes(originalRoutesStr);
    setSelectedAreas(originalAreasStr);
    setError("");
    setSuccess("");
  };

  if (loading)
    return (
      <div className="route-details-loading">
         <Loader onCancel={() => setIsLoading(false)} />
      </div>
    );
    

  return (
    <div className="route-details-container">
      {/*
        Layout safety net: long route names (e.g. multi-village route
        names) used to stretch the "New Route" <select> and push the
        whole table out of shape. These rules cap the column/select width
        and ellipsis-truncate overly long option text in the closed state.
      */}
      <style>{`
        .route-details-container .table-wrapper {
          overflow-x: auto;
        }
        .route-details-container table.unlock-dcr-leave-table {
          table-layout: fixed;
          width: 100%;
        }
        .route-details-container .route-dropdown,
        .route-details-container .area-dropdown {
          max-width: 280px;
          width: 100%;
          box-sizing: border-box;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .route-details-container td {
          word-break: break-word;
        }
        .route-details-container th[data-col="new-route"],
        .route-details-container td[data-col="new-route"] {
          max-width: 300px;
        }
      `}</style>

      <div className="route-details-header" style={{ textAlign: "center" }}>
        <h1>Assign Retailer to Routes</h1>
        <p style={{ marginTop: 6 }}>
          {effectiveRetailerId
            ? `Viewing retailer ${effectiveRetailerId} (type: ${qsRetailerType})`
            : `Viewing route ${effectiveRouteId || "N/A"}`}
        </p>
      </div>

      {error && <div style={{ color: "red", marginTop: 8 }}>{error}</div>}
      {success && <div style={{ color: "green", marginTop: 8 }}>{success}</div>}

      <div className="border rounded shadow table-wrapper">
        <table className="unlock-dcr-leave-table text-sm w-full">
          <thead className="bg-blue-500 text-white text-center">
            <tr>
              <th style={{ padding: 8 }}>S.No</th>
              <th style={{ padding: 8 }}>Id</th>
              <th style={{ padding: 8 }}>Code</th>
              <th style={{ padding: 8 }}>Retailer</th>
              <th style={{ padding: 8 }}>Mobile</th>
              <th style={{ padding: 8 }}>Present Route</th>
              <th style={{ padding: 8 }} data-col="new-route">
                New Route
              </th>
              <th style={{ padding: 8 }}>Area</th>
              <th style={{ padding: 8 }}>City</th>
            </tr>
          </thead>

          <tbody className="text-center">
            {retailers.length > 0 ? (
              retailers.map((retailer, index) => (
                <tr key={retailer.id} style={{ borderTop: "1px solid #eee" }}>
                  <td style={{ padding: 8 }}>{index + 1}</td>

                  <td style={{ padding: 8 }}>
                    {retailer.setup_code ?? retailer.id}
                  </td>
                  <td style={{ padding: 8 }}>{retailer.code}</td>
                  <td style={{ padding: 8 }}>{retailer.name}</td>
                  <td style={{ padding: 8 }}>{retailer.mobile || "N/A"}</td>

                  <td style={{ padding: 8 }}>
                    {retailer.route_name ||
                      retailer.current_route_name ||
                      "N/A"}
                  </td>

                  <td style={{ padding: 8 }} data-col="new-route">
                    <select
                      value={String(selectedRoutes[retailer.id] ?? "")}
                      onChange={(e) =>
                        handleRouteChange(retailer.id, e.target.value)
                      }
                      className="route-dropdown text-center"
                      title={
                        getRouteOptionsForRetailer(retailer.id).find(
                          (route) =>
                            String(route.id) ===
                            String(selectedRoutes[retailer.id] ?? "")
                        )?.name || ""
                      }
                    >
                      <option value="">Select Route</option>
                      {getRouteOptionsForRetailer(retailer.id).map((route) => (
                        <option key={String(route.id)} value={String(route.id)}>
                          {route.name}
                        </option>
                      ))}
                    </select>
                  </td>

                  <td style={{ padding: 8 }}>
                    <select
                      value={String(selectedAreas[retailer.id] ?? "")}
                      onChange={(e) =>
                        handleAreaChange(retailer.id, e.target.value)
                      }
                      className="area-dropdown text-center"
                    >
                      <option value="">Select Area</option>
                      {getAreaOptions(retailer.id).map((area) => (
                        <option key={String(area.id)} value={String(area.id)}>
                          {area.name}
                        </option>
                      ))}
                    </select>
                  </td>

                  <td style={{ padding: 8 }}>{retailer.city_name || "N/A"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={9} style={{ padding: 16, textAlign: "center" }}>
                  No retailers found for this route
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: 16, display: "flex", justifyContent: "center" }}>
        <CustomButton variant="save" onClick={handleSubmit}>
          Submit
        </CustomButton>
        <CustomButton
          variant="cancel"
          onClick={handleCancel}
          style={{ marginLeft: 8 }}
        >
          Cancel
        </CustomButton>
      </div>
    </div>
  );
};

export default RouteDetails;